import React, { useState, useEffect } from 'react'
import { InfoOutlined } from "@mui/icons-material";
import Pagination from '@mui/material/Pagination';
import { GETLoanLeadcountbyStatus, getLoanLeadById } from './actioncreatorNbfc';
import Loader from '../../../presentationals/Loader/Loader.component'

const statusStyle = {
    // background: '#f0f0f0',
    padding: '10px',
    borderRadius: '5px',
    cursor: 'pointer',
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: 'bold',
    margin: '5px',
    transition: 'background 0.3s',
};

const activeStatusStyle = {
    // background: '#f0f0f0',
    background: '#267dff',
    color: '#fff',
    padding: '10px',
    borderRadius: '5px',
    cursor: 'pointer',
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: 'bold',
    margin: '5px',
    transition: 'background 0.3s',
};
const itemsPerPage = 10;

export default function IndividualNBFCList({ admin, nbfcData,userDetailHandler }) {
    const [loader, setLoader] = useState(false)
    const [currentPage, setcurrentPage] = useState(1)
    const [data, setData] = useState([])
    const [statusData, setStatusData] = useState([])
    const [tab, setTab] = useState({})


    const handlePageChange = (event, value) => {
        setcurrentPage(value);
        getLoanLeadByIdFunction(tab, value)
    }

    const handleClicklead = (type) => {
        setTab(type)
        setcurrentPage(1);
        getLoanLeadByIdFunction(type, 1)
    }

    useEffect(() => {
        GETLoanLeadcountbyStatusFunction()
    }, [])

    const GETLoanLeadcountbyStatusFunction = () => {
        setLoader(true)
        GETLoanLeadcountbyStatus(nbfcData?.nbfcId, (callback) => {
            console.log(callback)
            setLoader(false)
            if (callback?.message == "success" && callback?.status == 200) {
                setStatusData(callback?.data)
                setTab(callback?.data[0])
                getLoanLeadByIdFunction(callback?.data[0], 1)
            } else {
                setStatusData([])
            }
        })
    }

    const getLoanLeadByIdFunction = (tabType, currentPage) => {
        setLoader(true)
        getLoanLeadById(nbfcData?.nbfcId, tabType.statusId, currentPage, itemsPerPage, (callback) => {
            setLoader(false)
            console.log("callback", callback)
            if (callback && callback?.message == "success" && callback?.status == 200) {
                setData(callback?.data)
            } else {
                setData([])
            }
        })
    }

    return (
        <>
            {
                loader ? <Loader /> : ''
            }
            <div className="box-outer" style={{}} >
                <div className="lead-status-container" style={{ display: 'flex', justifyContent: 'left', alignItems: 'center', flexWrap: 'wrap' }}>
                    {
                        statusData && statusData?.length > 0 ?
                            statusData?.map((value, index) => {
                                return (
                                    <div className="lead-status-item" onClick={() => handleClicklead(value)} style={tab?.statusName === value?.statusName ? activeStatusStyle : statusStyle} >
                                        <span>{value?.statusName}</span> <span style={{ color: tab?.statusName === value?.statusName ? "#fff" : '#999999' }}>({value?.counts})</span>
                                    </div>
                                )
                            })
                            : ''}

                </div>
                <div className="row">
                    <div className="col-sm-12 col-xs-12">

                        <div className="dash-table">
                            <table class="">
                                <thead>
                                    <tr>
                                        <th style={{minWidth:'150px'}}>Assign To</th>
                                        <th>Details</th>

                                        <th>Nach</th>
                                        <th style={{minWidth:'100px'}}>E-sign</th>

                                        <th style={{minWidth:'150px'}}>Application Id</th>
                                        <th style={{minWidth:'150px'}}>Crif Decision</th>
                                        <th>Loan ID</th>
                                        <th>Name</th>
                                        <th>State</th>
                                        <th style={{minWidth:'150px'}}>Mobile No.</th>
                                        <th>Apply Date</th>
                                        <th>Status</th>
                                        <th>Amount</th>
                                        <th>Installment</th>
                                        <th style={{minWidth:'150px'}}>Loan Form</th>
                                      
                                    </tr>
                                </thead>

                                <tbody>
                                    {
                                        data && data?.length > 0 ?
                                            data?.map((value, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{value?.assignTo || "-"}</td>
                                                        <td> <InfoOutlined  style={{cursor:'pointer'}} onClick={() => userDetailHandler(value)}/></td>

                                                        <td>{value?.nachStatus == true ? "Yes" : "No"}</td>
                                                        <td>{value?.esignStatus == 0 ? <i class="fa fa-times" aria-hidden="true" style={{color:'red'}}></i> : <i class="fa fa-check" aria-hidden="true" style={{color:'#14c814'}}></i>}</td>

                                                        <td>{value?.applicationId || "-"}</td>
                                                        <td>{value?.crifDecision || "-"}</td>
                                                        <td>{value?.loanId || "-"}</td>
                                                        <td style={{minWidth:'200px'}}>{value?.name || "-"}</td>
                                                        <td>{value?.state || "-"}</td>
                                                        <td>{value?.mobileNumber || "-"}</td>
                                                        <td style={{minWidth:'200px'}}>{value?.loanApplyDate || "-"}</td>
                                                        <td>{tab?.statusName || "-"}</td>
                                                        <td>{value?.loanAmount || "-"}</td>
                                                        <td>{value?.loanEmi || "-"}</td>
                                                        <td>{value?.loanFrom || "-"}</td>
                                                       

                                                    </tr>
                                                )
                                            })
                                    :''}


                                </tbody>
                            </table>

                        </div>
                        <div style={{ display: 'inline-block', float: 'right', margin: '30px 0 20px 0' }}>
                            <Pagination color="primary"
                                count={Math.ceil(tab?.counts / itemsPerPage)}
                                page={currentPage}
                                onChange={handlePageChange}
                            />
                        </div>

                    </div>
                </div>


            </div>
        </>
    )
}
